import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { siteWide } from '@helpers/grid';
import { Layers } from '@helpers/layers';
import { Device, until } from '@helpers/media';
import { mix } from 'polished';
import styled from 'styled-components';
import Button from '../Button/Button';
import ButtonStyles from '../Button/Button.styles';
import ModalBackdrop from '../ModalBackdrop/ModalBackdrop';
const Container = styled.section `
  ${transition('transform')};

  position: absolute;
  top: var(--headerHeight);
  left: 0;
  display: block;
  background: ${brand.white};
  padding: ${fluid(28, 64)} 0;
  width: 100%;
  z-index: 1;

  [data-scroll-active='true'] & {
    transform: translateY(
      calc((var(--headerTopHeightReduced) + var(--headerMessageHeight, 0px)) - var(--headerHeight))
    );
  }
`;
const Form = styled.form `
  ${siteWide};
`;
const InputWrapper = styled.div `
  position: relative;
  margin: 0 auto;
  max-width: 1128px;
  width: 100%;
`;
const Input = styled.input `
  /* Ensure iOS doesn't apply default border radius */
  -webkit-appearance: none !important;
  display: block;
  appearance: none;
  border: 0;
  border-bottom: 1px solid ${brand.green};
  color: ${brand.greyDark};
  ${fonts.brandonGrotesque.regular}
  font-size: ${fluid(20, 22)};
  height: 57px;
  line-height: 1em;
  padding: 0 122px 0 0;
  width: 100%;

  &::placeholder {
    color: ${mix(0.5, brand.greyDark, brand.white)};
  }

  @media ${until(Device.TabletSmall)} {
    padding: 0 54px 0 0;
  }
`;
const Submit = styled(Button) `
  position: absolute;
  top: 50%;
  right: 0;
  height: 46px !important;
  transform: translateY(-50%);
  width: 86px !important;

  ${ButtonStyles.IconWrapper} {
    height: 25px !important;
    width: 25px !important;
  }

  @media ${until(Device.TabletSmall)} {
    width: 46px !important;
  }
`;
const Backdrop = styled(ModalBackdrop) `
  z-index: ${Layers.HeaderBackdrop};
`;
const SearchDropdownStyles = {
    Backdrop,
    Container,
    Form,
    Input,
    InputWrapper,
    Submit,
};
export default SearchDropdownStyles;
